import { render, staticRenderFns } from "./TheSidebarLeft.vue?vue&type=template&id=24c9c1d4&"
import script from "./TheSidebarLeft.vue?vue&type=script&lang=js&"
export * from "./TheSidebarLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports